import { TrackingEventAction, sendTrackingEvent } from '../services/service.tracking';
import { getVehicleConfigData } from '../utils/utils.tracking';

const vehicleDetailEventResult = {
  continueErrIneligible: 'cta::continue_error::ineligible',
  linkAdIneligible: 'text-link::ineligible::place-an-ad',
  linkCarValueIneligible: 'text-link::ineligible::get-my-cars-value',
  seeAllFeaturesEquipment: 'text-link::see-all-features-equipment',
  seeStandardEquipment: 'text-link::see-standard-equipment',
} as const;

export const trackVehDetail = (eventResultKey: keyof typeof vehicleDetailEventResult, eventAction: TrackingEventAction) => {
  const eventResult = vehicleDetailEventResult[eventResultKey];
  const vehicleData = getVehicleConfigData();

  sendTrackingEvent({
    event: 'analytics_event',
    eventAction,
    eventResult,
    eventNonInteractive: false,
    eventData: { ...vehicleData },
  });
};

export const trackVehDetailImpression = () => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'impression',
    eventResult: 'ico_vehdetails',
    eventNonInteractive: false,
  });
};
